import { isArray } from "lodash";
import React from "react";
import { CANVAS_GUIDES, GUIDES } from "../Constants";

/**
 * Updates line element on given position, with given length and angle.
 */
function updateLineElement(x, y, length, angle, element, isSnapped) {
  try {
  
    const line = document.getElementById(element);
    const styles =
      `border-bottom: 1px ${isSnapped ? "solid #1f53ff": "dashed #fcb6b6"}; ` +
      "width: " +
      length +
      "px; " +
      "height: 0px; " +
      "-moz-transform: rotate(" +
      angle +
      "rad); " +
      "-webkit-transform: rotate(" +
      angle +
      "rad); " +
      "-o-transform: rotate(" +
      angle +
      "rad); " +
      "-ms-transform: rotate(" +
      angle +
      "rad); " +
      "position: absolute; " +
      "top: " +
      y +
      "px; " +
      "left: " +
      x +
      "px; ";

    line && line.setAttribute("style", styles);
  } catch (e) {
    console.error("error in draw guides ", e);
  }
}

/**
 * Creates element which represents line from point [x1, y1] to [x2, y2].
 * It is html div element with minimal height and width corresponding to line length.
 * It's position and rotation is calculated below.
 */
function createLine(x1, y1, x2, y2, element, isSnapped) {
  try {
    const a = x1 - x2,
      b = y1 - y2,
      c = Math.sqrt(a * a + b * b);

    const sx = (x1 + x2) / 2,
      sy = (y1 + y2) / 2;

    const x = sx - c / 2,
      y = sy;

    const alpha = Math.PI - Math.atan2(-b, a);

    updateLineElement(x, y, c, alpha, element, isSnapped);
  } catch (e) {
    console.error("error in draw guides ", e);
  }
}

export const drawGuides = (sectionId, page) => {
  try {
    const pageOffsets = document.getElementById(page).getBoundingClientRect();
    const offsets = document.getElementById(sectionId).getBoundingClientRect();

    const { isTopBottomLeft, isTopBottomRight, isTopLeftRight, isBottomLeftRight } = sectionAlignStatus(page, sectionId)

    const topY = offsets.top;
    const bottomY = offsets.bottom;
    const leftX = offsets.left;
    const rightX = offsets.right;

    const pageLeft = pageOffsets.left;
    const pageTop = pageOffsets.top;
    const pageRight = pageOffsets.right;
    const pageBottom = pageOffsets.bottom;

    createLine(leftX, topY, leftX, pageTop, GUIDES.GUIDES_TOP_LEFT_V, isTopBottomLeft);
    createLine(rightX, topY, rightX, pageTop, GUIDES.GUIDES_TOP_RIGHT_V, isTopBottomRight);
    createLine(leftX, topY, pageLeft, topY, GUIDES.GUIDES_BOTTOM_LEFT_V, isTopLeftRight);
    createLine(leftX, bottomY, pageLeft, bottomY, GUIDES.GUIDES_BOTTOM_RIGHT_V, isBottomLeftRight);
    createLine(leftX, bottomY, leftX, pageBottom, GUIDES.GUIDES_TOP_LEFT_H, isTopBottomLeft);
    createLine(
      rightX,
      bottomY,
      rightX,
      pageBottom,
      GUIDES.GUIDES_BOTTOM_LEFT_H,
      isTopBottomRight
    );
    createLine(rightX, topY, pageRight, topY, GUIDES.GUIDES_TOP_RIGHT_H, isTopLeftRight);
    createLine(
      rightX,
      bottomY,
      pageRight,
      bottomY,
      GUIDES.GUIDES_BOTTOM_RIGHT_H,
      isBottomLeftRight
    );
  } catch (e) {
    console.error("error in draw guides ", e);
  }
};

/**
 * @description Get align status of each guides.
 * @param pageId Selected page ID.
 * @param sectionId Selected section ID.
 * @param event Section move event.
 */
export const sectionAlignStatus = (pageId, sectionId, event) => {
  try {
    // Get all sections positions except selected one.
    let restSections = [];
    const sections = document
      .getElementById(pageId)
      .querySelectorAll(".usc-section");

    sections?.forEach((element) => {
      if (element.id != sectionId) {
        restSections.push(element.getBoundingClientRect());
      }
    });

    const offsets = document.getElementById(sectionId).getBoundingClientRect();

    // Checking if left side guides of selected section are collides with other sections.
    const isTopBottomLeft = restSections.some(
      ({ left, right }) =>
      Math.round(left) === Math.round(offsets.left) ||
      Math.round(right) === Math.round(offsets.left)
    );
    // Checking if right side guides of selected section are collides with other sections.
    const isTopBottomRight = restSections.some(
      ({ left, right }) =>
        Math.round(right) === Math.round(offsets.right) ||
        Math.round(left) === Math.round(offsets.right)
    );
    // Checking if top side guides of selected section are collides with other sections.
    const isTopLeftRight = restSections.some(
      ({ top, bottom }) =>
        Math.round(top) === Math.round(offsets.top) ||
        Math.round(bottom) === Math.round(offsets.top)
    );
    // Checking if bottom side guides of selected section are collides with other sections.
    const isBottomLeftRight = restSections.some(
      ({ top, bottom }) =>
        Math.round(bottom) === Math.round(offsets.bottom) ||
        Math.round(top) === Math.round(offsets.bottom)
    );
    
    // This status return true until move event velocity is greater than 150,
    // Also the section can move in the opposite direction by taking the snapped X and Y status separately.
    const isSnappedXDirection = event
      ? (isTopBottomLeft || isTopBottomRight) &&
        event?.velocity?.x > -150 &&
        event?.velocity?.x < 150
      : false;

    const isSnappedYDirection = event
      ? (isTopLeftRight || isBottomLeftRight) &&
        event?.velocity?.y > -150 &&
        event?.velocity?.y < 150
      : false;
    
    return {
      isTopBottomLeft,
      isTopBottomRight,
      isTopLeftRight,
      isBottomLeftRight,
      isSnappedXDirection,
      isSnappedYDirection
    };
  } catch (e) {
    return {
      isTopBottomLeft: false,
      isTopBottomRight: false,
      isTopLeftRight: false,
      isBottomLeftRight: false,
      isSnappedXDirection: false,
      isSnappedYDirection: false
    };
  }
}

export const hideGuides = () => {
  try {
    CANVAS_GUIDES.map((guide) => {
      const guideElement = document.getElementById(guide);
      guideElement && guideElement.removeAttribute("style");
    });
  } catch (e) {
    console.error("error in draw guides ", e);
  }
};

export const createGuides = () => {
  try {
    CANVAS_GUIDES.map((guide) => {
      let sectionGuides = document.createElement("div");
      sectionGuides.setAttribute("id", guide);
      document.body.appendChild(sectionGuides);
    });
  } catch (e) {
    console.error("error in draw guides ", e);
  }
};

export const searchValues = (dataSource, searchText, fieldName) => {
  try {
    if (isArray(dataSource) && dataSource.length > 0) {
      return dataSource.filter((data) => {
        return Object.keys(data).some((k) =>
          String(data[fieldName])
            .toLowerCase()
            .includes(searchText?.toLowerCase())
        );
      });
    } else {
      return [];
    }
  } catch (error) {
    return dataSource;
  }
};

// and finally, my getCorrectDroppedOffsetValue function
export const getCorrectDroppedOffsetValue = (
  initialPosition,
  finalPosition
) => {
  // get the container (view port) position by react ref...
  const container = document.getElementById("divUSCPageContent");
  const dropTargetPosition = container.getBoundingClientRect();

  const { y: finalY, x: finalX } = finalPosition;
  const { y: initialY, x: initialX } = initialPosition;

  // calculate the correct position removing the viewport position.
  // finalY > initialY, I'm dragging down, otherwise, dragging up
  const newYPosition =
    finalY > initialY
      ? initialY + (finalY - initialY) - dropTargetPosition.top
      : initialY - (initialY - finalY) - dropTargetPosition.top;

  const newXPosition =
    finalX > initialX
      ? initialX + (finalX - initialX) - dropTargetPosition.left
      : initialX - (initialX - finalX) - dropTargetPosition.left;
  const PAGE_HEIGHT = 1123.2; // get this as param
  return {
    x: newXPosition,
    y: newYPosition % PAGE_HEIGHT,
  };
};

/**
 * @description - Stick tool bar into selected section.
 * @param sectionId - selected section id
 */
export const setToolBarOffset = (sectionId) => {
  try {
    if (sectionId) {
      const sectionOffset = document
        .getElementById(sectionId)
        ?.getBoundingClientRect();
      const offsetTop = Number(sectionOffset?.top);
      const toolBar = document.getElementById("tool-bar");
      const styles =
        "top: " +
        ((offsetTop > 79 ? offsetTop : 79) - 120) +
        "px; " +
        "left: " +
        sectionOffset?.left +
        "px; ";
      toolBar && sectionOffset && toolBar.setAttribute("style", styles);
    }
  } catch (e) {
    console.error("toolBar scroll error", e);
  }
};
